var exports = {
  "a": "ChartCardDescriptionText__7Lo3AT",
};

module.exports = exports;
